import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { AppState } from '../../..';
import { TransactionCoordinatorViewModel } from '@models/TransactionCoordinator';
import {
  getTransactionCoordinator,
  saveTransactionCoordinator,
  lookupOffice,
  updateOfficeId,
  clearTransactionCoordinatorState
} from '../../transaction-coordinator.actions';
import {
  TransactionCoordinatorComponent,
  TransactionCoordinatorComponentProperties
} from './transaction-coordinator.component';

// This is used to translate the state of the page to the props on the component
function mapStateToProps(state: AppState): Partial<TransactionCoordinatorComponentProperties> {
  return {
    message: state.transactionCoordinator.message,
    realEstateOffice: state.transactionCoordinator.realEstateOffice,
    saving: state.transactionCoordinator.saving,
    txCoordinator: state.transactionCoordinator.transactionCoordinatorVM
  };
}

// This should create proxy wrappers for actions used by the component
function mapDispatchToProps(
  dispatch: Dispatch<AppState>,
  ownProps: { saveCallback: Function }
): Partial<TransactionCoordinatorComponentProperties> {
  return {
    onSaveClick: (values: TransactionCoordinatorViewModel) => {
      let newValues = Object.assign({}, values);
      const address = values.address;
      if (
        address &&
        ((address.line1 === '' || address.line1 === undefined) &&
          (address.city === '' || address.city === undefined) &&
          (address.state === undefined || (address.state && address.state!.abbreviation === '-1')) &&
          (address.zip === '' || address.zip === undefined))
      ) {
        newValues.address = null;
      }
      dispatch(saveTransactionCoordinator(newValues, ownProps.saveCallback));
    },
    getTransactionCoordinator: (id?: number) => {
      dispatch(getTransactionCoordinator(id));
    },
    officeLookup(value: string, id?: number) {
      return lookupOffice(value, id);
    },
    clearTransactionCoordinatorState: () => {
      dispatch(clearTransactionCoordinatorState);
    },
    updateOfficeValue: updateOfficeId
  };
}

// Connect function "wires" both of the map functions and returns a wrapper container for the component
export const TransactionCoordinator = connect(
  mapStateToProps,
  mapDispatchToProps
)(TransactionCoordinatorComponent);



// WEBPACK FOOTER //
// ./src/transaction-coordinator/_components/transaction-coordinator/transaction-coordinator.container.ts